export default {"src":"/_next/static/media/ic-facebook.094a9e36.svg","height":32,"width":31};